import App from "../../core/src/App";
import { Ease } from "../../core/src/Ease";
import BetModel from "../../core/src/model/BetModel";
import GameModel from "../../core/src/model/GameModel";
import IJackpotData from "../server/data/IJackpotData";
import BangUp from "../../core/src/utils/BangUp";
import Layout from "../../core/src/utils/Layout";
import JackpotsModel from "../model/JackpotsModel";
import FullscreenUtils from "../../core/src/utils/FullscreenUtils";
import ConsoleUtil from "../../core/src/utils/ConsoleUtil";
import CurrencyUtils from "../../core/src/utils/CurrencyUtils";
import ConfigManager from "../../core/src/managers/ConfigManager";
import Configs from "../vendorConfigs/Configs";
import { ConfigurationTypes } from "../../core/src/const/ConfigurationTypes";
import { CurrencyType } from "../../core/src/managers/contracts/configurations/IBetConfig";
class VendorWrapper {
    protected START_HEIGHT: number;
    protected START_WIDTH: number;
    protected hasPromo: boolean;
    protected promoLandscapeSwitchPredicate: () => boolean;
    private jackpotsInitialized: boolean = false;
    private lastOrientationWasLandscape: boolean;

    init(
        START_WIDTH,
        START_HEIGHT,
        hasPromo = false,
        promoLandscapeSwitchPredicate: () => boolean = () => {
            return window.innerWidth > window.innerHeight;
        }
    ) {
        this.START_WIDTH = START_WIDTH;
        this.START_HEIGHT = START_HEIGHT;
        this.hasPromo = hasPromo;
        this.promoLandscapeSwitchPredicate = promoLandscapeSwitchPredicate;
        if (!GameModel.gameConfig.debugLogging || GameModel.gameConfig.debugLogging.resizeScreen === true) {
            this.localLog = ConsoleUtil.log;
        }

        // Due to fullscreen utils has been deprecated,
        // we need to check whether the game canvas is too small.
        // FOR FULL SCREEN ISSUES ADJUST THE INTERVAL CALLBACK TIME
        if (GameModel.isMobile(true)) {
            setInterval(() => {
                if (App.instance.view.clientWidth < window.innerWidth * 0.80 ||
                    App.instance.view.clientHeight < window.innerHeight * 0.80) {
                    // Game canvas is too small
                    this._onResize(true);
                }
            }, 250)
        }
    }

    get onResize() {
        return () => {
            this._onResize();
        };
    }
    private localLog = (content?) => { };

    private lastWidth: number;
    private lastHeight: number;

    _onResize(force: boolean = false) {
        if (!force && window.innerWidth == this.lastWidth && window.innerHeight == this.lastHeight) {
            return;
        }
        // doesn't show History popup when enabled
        /* const scale = "scale(1)";
        document.body.style.webkitTransform = scale; */ // Chrome, Opera, Safari
        // document.body.style.msTransform = scale;        // IE 9 //TODO
        //document.body.style.transform = scale; // General

        let updatePromo = this.hasPromo && JackpotsModel.jackpotsAvailable;
        const landscape = updatePromo
            ? this.promoLandscapeSwitchPredicate()
            : window.innerWidth > window.innerHeight;
        let promoElement = document.getElementById(
            `jackpotBanner${landscape ? "Landscape" : "Portrait"}`
        );
        let replayElement = document.getElementById("replayIframe");

        this.updateJackpots();

        // const vpWidth = window.innerWidth-300/window.devicePixelRatio;
        // debugger;
        const vpWidth =
            window.innerWidth -
            (landscape && promoElement && updatePromo
                ? promoElement.offsetWidth
                : 0);
        const vpHeight =
            window.innerHeight -
            (updatePromo && !landscape && promoElement
                ? promoElement.offsetHeight
                : 0);

        // w_promotion_content

        this.localLog(
            "innerWidth : " +
            window.innerWidth +
            " innerHeight : " +
            window.innerHeight
        );

        let scaleFactor;
        let newWidth;
        let newHeight;

        scaleFactor = Math.min(
            vpWidth / this.START_WIDTH,
            vpHeight / this.START_HEIGHT
        );
        newWidth = vpWidth;
        newHeight = vpHeight;

        this.localLog(
            "Resizing to w:" +
            newWidth +
            " h:" +
            newHeight +
            " scaleFactor:" +
            scaleFactor
        );

        newWidth = Math.ceil(newWidth);
        newHeight = Math.ceil(newHeight);

        App.instance.renderer.resize(
            newWidth / scaleFactor,
            newHeight / scaleFactor
        );
        // app.stage.scale.set(scaleFactor);
        App.instance.stage.scale.set(1);

        // TODO: Check if this works better
        // Layout.onResize(newWidth / scaleFactor, newHeight / scaleFactor);
        Layout.onResize(window.innerWidth, window.innerHeight);

        App.instance.renderer.view.style.position = "absolute";
        App.instance.renderer.view.style.width = `${newWidth}px`;
        if (updatePromo) {
            this.updateJackpots();
            if (landscape) {
                App.instance.renderer.view.style.left = promoElement
                    ? `${promoElement.offsetWidth}px`
                    : `0px`;
                App.instance.renderer.view.style.top = "0px";
                if (promoElement && promoElement.style) {
                    promoElement.style.height = window.innerHeight + "px";
                }
            } else {
                App.instance.renderer.view.style.left = "0px";
                App.instance.renderer.view.style.top = promoElement
                    ? `${promoElement.offsetHeight}px`
                    : `0px`;
            }
        }
        App.instance.renderer.view.style.height = `${newHeight}px`;

        if (replayElement) {
            replayElement.style.position = "absolute";
            replayElement.style.width = `${newWidth}px`;
            replayElement.style.height = `${newHeight}px`;
        }

        this.lastWidth = window.innerWidth;
        this.lastHeight = window.innerHeight;
    }

    private initializeJackpots() {
        if (this.jackpotsInitialized) {
            return;
        }

        if (JackpotsModel.jackpotNames.length > 0) {
            let bannerLandscape = this.createJackpotBanner(true);
            document.body.prepend(bannerLandscape);
            let bannerPortrait = this.createJackpotBanner(false);
            document.body.prepend(bannerPortrait);
            document.getElementById("content").classList.add("noselect");
        }

        this.jackpotsInitialized = true;
    }

    private createJackpotBanner(landscape: boolean) {
        let suffix = landscape ? "Landscape" : "Portrait";
        // Creating the main div
        let id = "jackpotBanner" + suffix;
        let div = document.createElement("div");
        div.id = id;
        div.classList.add("jackpotBackground" + suffix);
        div.classList.add("noselect");
        div.classList.add("jackpotFont");
        div.classList.add("jackpotBackgroundColor" + suffix);

        // Creating a table
        let table = document.createElement("table");
        table.cellSpacing = "0";
        table.style.borderCollapse = "collapse";
        table.style.border = "none";
        table.style.width = "100%";
        let body = document.createElement("tbody");
        table.appendChild(body);

        if (landscape) {
            this.fillTableBodyLandscape(body);
        } else {
            this.fillTableBodyPortrait(body);
        }

        div.appendChild(table);
        return div;
    }

    private fillTableBodyLandscape(body: HTMLTableSectionElement) {
        const config = ConfigManager.getConfig(ConfigurationTypes.JACKPOT_BANNER);
        // Header
        let header = document.createElement("tr");
        header.style.height = config?.headerHeightLandscape || "27.6vh";
        header.style.width = "100px";
        let headerTd = document.createElement("td");
        headerTd.className = "jackpotCellLandscape";
        header.appendChild(headerTd);
        body.appendChild(header);

        JackpotsModel.jackpotNames.forEach((jackpot, index) => {
            // Image
            let image = document.createElement("tr");
            let selector = jackpot.toLowerCase() + "JackpotImage";
            let custom = false;
            if (this.selectorExistsAt("jackpot.css", "." + selector)) {
                image.classList.add(selector);
            } else {
                // This is a custom jackpot
                custom = true;
            }

            image.classList.add("jackpotBackgroundLandscape");
            image.classList.add(jackpot.toLowerCase());
            let imageTd = document.createElement("td");
            imageTd.classList.add("jackpotCellLandscape");
            if (custom) {
                imageTd.innerText = jackpot;
                imageTd.classList.add("customJackpot");
                imageTd.classList.add("jackpotColor");
            }

            image.appendChild(imageTd);
            body.appendChild(image);

            // Frame
            let frame = document.createElement("tr");
            frame.classList.add("jackpotFrameLandscape");
            frame.classList.add("jackpotBackgroundLandscape");
            frame.classList.add(jackpot.toLowerCase());
            let frameTd = document.createElement("td");
            frameTd.classList.add("jackpotCellLandscape");
            frameTd.classList.add("jackpotValueLandscape");
            frameTd.classList.add("jackpotColor");
            frame.appendChild(frameTd);
            body.appendChild(frame);
        });
    }

    private fillTableBodyPortrait(body: HTMLTableSectionElement) {
        const config = ConfigManager.getConfig(ConfigurationTypes.JACKPOT_BANNER);
        let header = document.createElement("tr");
        // header.style.height = "4.2vw";
        header.style.height = config?.headerHeightPortrait || "3.0vw";
        let row1 = document.createElement("tr");
        let row2 = document.createElement("tr");

        JackpotsModel.jackpotNames.forEach((jackpot, index) => {
            // Header cells
            let headerTd = document.createElement("td");
            headerTd.classList.add("jackpotCellPortrait");
            header.appendChild(headerTd);

            // Image cells
            let image = document.createElement("td");
            let selector = jackpot.toLowerCase() + "JackpotImage";
            if (this.selectorExistsAt("jackpot.css", "." + selector)) {
                image.classList.add(selector);
            } else {
                // This is a custom jackpot
                image.innerText = jackpot;
                image.classList.add("customJackpot");
                image.classList.add("jackpotColor");
            }

            image.classList.add("jackpotBackgroundPortrait");
            image.classList.add("jackpotCellPortrait");
            row1.appendChild(image);

            // Frame cells
            let frame = document.createElement("td");
            frame.classList.add("jackpotFramePortrait");
            frame.classList.add("jackpotBackgroundPortrait");
            frame.classList.add("jackpotCellPortrait");
            frame.classList.add("jackpotValuePortrait");
            frame.classList.add("jackpotColor");
            frame.classList.add(jackpot.toLowerCase());
            row2.appendChild(frame);
        });

        body.appendChild(header);
        body.appendChild(row1);
        body.appendChild(row2);
    }

    public setJackpotValues(jackpots: IJackpotData[]) {
        // Lazy load
        this.initializeJackpots();

        let modes = ["Landscape", "Portrait"];
        for (let i = 0; i < modes.length; i++) {
            let elements = Array.from(
                document.querySelectorAll<HTMLElement>(
                    "#jackpotBanner" + modes[i] + " .jackpotValue" + modes[i]
                )
            );

            elements.forEach((element) => {
                JackpotsModel.jackpotNames.forEach(jackpotName => {
                    if (element.classList.contains(jackpotName.toLowerCase()) || element.parentElement.classList.contains(jackpotName.toLowerCase())) {
                        this.bangUpJackpotValue(element, Number(jackpots.find(jackpot => jackpot.name == jackpotName).amount));
                    }
                });
            });
        }

        this._onResize(true);
    }

    private bangUpJackpotValue(element: HTMLElement, amount: number) {
        let currentBangup = new BangUp();
        let bangUpVal = 0;
        let startValue = CurrencyUtils.parseCurrency(element.innerText, BetModel.currencyLocalization);
        if (startValue == amount) {
            // No changes
            return;
        }

        const testMultiplier = 1;
        currentBangup.startBangup(
            startValue,
            amount,
            3,
            { ease: Ease.None },
            (val) => {
                val *= testMultiplier;
                bangUpVal = val;
                const originalText = element.innerText;
                const exactValue: string =
                    Configs.bet.primaryCurrencyType == CurrencyType.Money
                        ? CurrencyUtils.formatCurrency(bangUpVal, BetModel.currencyLocalization, true)
                        : bangUpVal.toFixed(BetModel.currency.decimals);

                element.innerText = exactValue;

                if (originalText.length != element.innerText.length) {
                    this.autoFitJackpotValue();
                }
            },
            () => {
                // on complete action...
                this.autoFitJackpotValue();
            }
        );
    }

    private updateJackpots() {
        if (!this.jackpotsInitialized) {
            return;
        }

        let isNowLandscape = this.promoLandscapeSwitchPredicate();
        let modeChanged = this.lastOrientationWasLandscape != isNowLandscape;
        this.lastOrientationWasLandscape = isNowLandscape;

        if (modeChanged) {
            // console.log(
            //     "mode changed to " + (isNowLandscape ? "landscape" : "portrait")
            // );

            document.getElementById("jackpotBannerLandscape").style.display =
                isNowLandscape ? "block" : "none";
            document.getElementById("jackpotBannerPortrait").style.display =
                isNowLandscape ? "none" : "block";
        }

        this.autoFitJackpotValue();
    }

    private autoFitJackpotValue() {
        let landscape = this.lastOrientationWasLandscape;
        // Autofit logic
        let fields = Array.from(
            document.querySelectorAll<HTMLElement>(
                ".jackpotValue" + (landscape ? "Landscape" : "Portrait")
            )
        );

        let longestText = "";
        let field = undefined;
        fields.forEach((f) => {
            let text = f.innerText;
            if (longestText.length <= text.length) {
                longestText = text;
                field = f;
            }
        });

        if (field == undefined || longestText.length == 0) {
            return;
        }

        let id = "jackpotBanner" + (landscape ? "Landscape" : "Portrait");
        let element = document.getElementById(id);
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let family = window
            .getComputedStyle(field)
            .getPropertyValue("font-family");
        let newSize = 1;
        let step = 1;

        let columnsCount = landscape ? 1 : JackpotsModel.jackpotNames.length;

        // Setting up the default scale factors
        let scaleCoefWidth = landscape ? 0.62 : 0.80;
        let scaleCoefHeight = landscape ? 0.31 : 0.31;

        // Checking for overriden scale factors
        let config = landscape ?
            GameModel.gameConfig.jackpotTextScalesLandscape :
            GameModel.gameConfig.jackpotTextScalesPortrait;

        if (config) {
            scaleCoefWidth = config[0];
            scaleCoefHeight = config[1];
        }

        let maxWidth = (element.offsetWidth / columnsCount) * scaleCoefWidth;
        if (maxWidth <= 10) {
            // throw new Error("maxWidth too small: " + maxWidth);
            return;
        }

        const maxHeight: number = field.clientHeight * scaleCoefHeight;
        let iterations = 0;
        while (true) {
            if (iterations >= 100) {
                // throw new Error(`Jackpot text autoFit logic failed after ${iterations} interations!`);
                return;
            }

            ctx.font = `${newSize}px ${family}`;
            let measure = ctx.measureText(longestText);
            let height = measure.actualBoundingBoxAscent + measure.actualBoundingBoxDescent;
            if (measure.width >= maxWidth || height >= maxHeight) {
                let finalFontSize =
                    Math.max(
                        1,
                        newSize
                    ) + "px";
                Array.from(
                    document.querySelectorAll<HTMLElement>(
                        ".jackpotValueLandscape"
                    )
                ).forEach((landscapeValue) => {
                    landscapeValue.style.fontSize = finalFontSize;
                });
                Array.from(
                    document.querySelectorAll<HTMLElement>(
                        ".jackpotValuePortrait"
                    )
                ).forEach((portraitValue) => {
                    portraitValue.style.fontSize = finalFontSize;
                });

                // The same for the custom jackpot texts
                Array.from(
                    document.querySelectorAll<HTMLElement>(
                        ".customJackpot"
                    )
                ).forEach((customValue) => {
                    customValue.style.fontSize = finalFontSize;
                });

                break;
            }

            newSize += step;
            iterations++;
        }
    }

    /**
     * This function searches for the existence of a specified CSS selector in a given stylesheet.
     *
     * @param (string) styleSheetName - This is the name of the stylesheet you'd like to search, including the file extension.
     * @param (string) selector - This is the name of the selector you'd like to find. Include the . for class, # for id, etc.selector.
     * @return (bool) - Returns true if the selector is found, false if it's not found
     * @example - console.log(selectorInStyleSheet ('myStyleSheet.css', '.myClass'));
     */

    private selectorExistsAt(styleSheetName, selector) {
        // Get the index of 'styleSheetName' from the document.styleSheets object
        for (var i = 0; i < document.styleSheets.length; i++) {
            var thisStyleSheet = document.styleSheets[i].href
                ? document.styleSheets[i].href.replace(/^.*[\\\/]/, "")
                : "";
            if (thisStyleSheet == styleSheetName) {
                var idx = i;
                break;
            }
        }
        if (!idx) {
            // We can't find the specified stylesheet
            return false;
        }

        // Check the stylesheet for the specified selector
        var styleSheet = document.styleSheets[idx];
        var cssRules = styleSheet.rules
            ? styleSheet.rules
            : styleSheet.cssRules;
        for (var i = 0; i < cssRules.length; ++i) {
            // @ts-ignore
            let selectorText = cssRules[i].selectorText;
            if (selectorText == selector) {
                return true;
            }
        }

        return false;
    }
}

export default new VendorWrapper();
